export default __webpack_public_path__ + "static/media/arch-wordmark.d2ea767a.png";